import { jsxs, jsx } from 'react/jsx-runtime';
import { NeutralColors, getScreenSelector, ScreenWidthMaxXLarge, Stack, PrimaryButton, DefaultButton, Nav } from '@fluentui/react';
import { useBreakpoint } from '@agoras/hooks';
import { useContext, useMemo, useState, useCallback } from 'react';
import MenuHeader from '../MenuHeader/MenuHeader.esm.js';
import IndustryClouds from './IndustryClouds/IndustryClouds.esm.js';
import AppsByIndustries from './AppsByIndustries/AppsByIndustries.esm.js';
import { AppContext } from '../../../context/context.esm.js';
import { useTranslation } from 'react-i18next';
import logger from '@agoras/logger';
import { headerContext } from '../../context.esm.js';

function _array_like_to_array(arr, len) {
    if (len == null || len > arr.length) len = arr.length;
    for(var i = 0, arr2 = new Array(len); i < len; i++)arr2[i] = arr[i];
    return arr2;
}
function _array_with_holes(arr) {
    if (Array.isArray(arr)) return arr;
}
function _define_property(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _iterable_to_array_limit(arr, i) {
    var _i = arr == null ? null : typeof Symbol !== "undefined" && arr[Symbol.iterator] || arr["@@iterator"];
    if (_i == null) return;
    var _arr = [];
    var _n = true;
    var _d = false;
    var _s, _e;
    try {
        for(_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true){
            _arr.push(_s.value);
            if (i && _arr.length === i) break;
        }
    } catch (err) {
        _d = true;
        _e = err;
    } finally{
        try {
            if (!_n && _i["return"] != null) _i["return"]();
        } finally{
            if (_d) throw _e;
        }
    }
    return _arr;
}
function _non_iterable_rest() {
    throw new TypeError("Invalid attempt to destructure non-iterable instance.\\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function _object_spread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            _define_property(target, key, source[key]);
        });
    }
    return target;
}
function ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        keys.push.apply(keys, symbols);
    }
    return keys;
}
function _object_spread_props(target, source) {
    source = source != null ? source : {};
    if (Object.getOwnPropertyDescriptors) {
        Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    } else {
        ownKeys(Object(source)).forEach(function(key) {
            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
    }
    return target;
}
function _sliced_to_array(arr, i) {
    return _array_with_holes(arr) || _iterable_to_array_limit(arr, i) || _unsupported_iterable_to_array(arr, i) || _non_iterable_rest();
}
function _unsupported_iterable_to_array(o, minLen) {
    if (!o) return;
    if (typeof o === "string") return _array_like_to_array(o, minLen);
    var n = Object.prototype.toString.call(o).slice(8, -1);
    if (n === "Object" && o.constructor) n = o.constructor.name;
    if (n === "Map" || n === "Set") return Array.from(n);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _array_like_to_array(o, minLen);
}
var links = function(param) {
    var unifiedExperience = param.unifiedExperience;
    return [
        {
            name: 'Microsoft Industry Clouds',
            key: 'microsoftIndustryClouds',
            url: '',
            component: IndustryClouds
        },
        {
            name: unifiedExperience ? 'Products by industries' : 'Apps by industries',
            key: 'appsByIndustries',
            url: '',
            component: AppsByIndustries
        }
    ];
};
var navStyles = {
    link: _define_property({
        whiteSpace: 'normal',
        lineHeight: 'inherit',
        minHeight: 44,
        height: 'auto',
        padding: '12px 32px 12px 32px'
    }, getScreenSelector(undefined, ScreenWidthMaxXLarge), {
        padding: '12px 16px 12px 16px'
    }),
    linkText: {
        color: NeutralColors.gray160
    }
};
var IndustriesMenu = function(param) {
    var onLinkClick = param.onLinkClick;
    var t = useTranslation('header').t;
    var _useBreakpoint = _sliced_to_array(useBreakpoint('xl'), 1), isXL = _useBreakpoint[0];
    var _useContext = useContext(AppContext), navigate = _useContext.navigate, unifiedExperience = _useContext.unifiedExperience;
    var linksByStore = useMemo(function() {
        return links({
            unifiedExperience: unifiedExperience
        });
    }, [
        unifiedExperience
    ]);
    var _useState = _sliced_to_array(useState(linksByStore[0].key), 2), selectedLinkKey = _useState[0], setSelectedLink = _useState[1];
    var appsGroups = useMemo(function() {
        return linksByStore.map(function(link) {
            return _object_spread_props(_object_spread({}, link), {
                name: t(link.name),
                onClick: function() {
                    logger.info(JSON.stringify({
                        key: 'Industries',
                        tab: link.key
                    }), _object_spread({
                        action: 'MegaMenu',
                        actionModifier: 'Click tab'
                    }, headerContext));
                    setSelectedLink(link.key);
                }
            });
        });
    }, [
        setSelectedLink,
        linksByStore,
        t
    ]);
    var selectedApp = useMemo(function() {
        return appsGroups.find(function(app) {
            return app.key === selectedLinkKey;
        });
    }, [
        appsGroups,
        selectedLinkKey
    ]);
    var _ref = selectedApp || {}, SelectedAppComponent = _ref.component;
    var handleRenderButtonsContent = useCallback(function() {
        return /*#__PURE__*/ jsxs(Stack, {
            horizontal: true,
            tokens: {
                childrenGap: 8
            },
            children: [
                /*#__PURE__*/ jsx(PrimaryButton, {
                    onClick: function() {
                        logger.info(JSON.stringify({
                            key: 'Industries',
                            name: 'See all Microsoft Industry Clouds'
                        }), _object_spread({
                            action: 'MegaMenu',
                            actionModifier: 'Click button'
                        }, headerContext));
                        navigate({
                            type: 'CloudsIndustry'
                        });
                        onLinkClick();
                    },
                    children: t('See all Microsoft Industry Clouds')
                }),
                /*#__PURE__*/ jsx(DefaultButton, {
                    onClick: function() {
                        logger.info(JSON.stringify({
                            key: 'Industries',
                            name: 'See all industries'
                        }), _object_spread({
                            action: 'MegaMenu',
                            actionModifier: 'Click button'
                        }, headerContext));
                        navigate({
                            type: 'App'
                        });
                        onLinkClick();
                    },
                    children: t('See all industries')
                })
            ]
        });
    }, [
        navigate,
        onLinkClick,
        t
    ]);
    return /*#__PURE__*/ jsxs(Stack, {
        children: [
            /*#__PURE__*/ jsx(MenuHeader, {
                title: t('Browse by industries'),
                subTitle: unifiedExperience ? t('Explore industries to find the right product or professional service for your unique industry needs.') : t('Explore industries to find the right app or consulting service for your unique industry needs.'),
                onRenderButtonsContent: handleRenderButtonsContent
            }),
            /*#__PURE__*/ jsxs(Stack, {
                horizontal: true,
                tokens: {
                    childrenGap: isXL ? 16 : 32,
                    padding: isXL ? '24px 28px' : 32
                },
                styles: {
                    root: {
                        width: '100%'
                    }
                },
                children: [
                    /*#__PURE__*/ jsx(Stack.Item, {
                        grow: isXL ? 3 : 2,
                        basis: 0,
                        shrink: 0,
                        styles: {
                            root: {
                                width: 'min-content'
                            }
                        },
                        children: /*#__PURE__*/ jsx(Nav, {
                            groups: [
                                {
                                    links: appsGroups
                                }
                            ],
                            styles: navStyles,
                            selectedKey: selectedLinkKey
                        })
                    }),
                    /*#__PURE__*/ jsx(Stack.Item, {
                        grow: 9,
                        basis: 0,
                        shrink: 0,
                        styles: {
                            root: {
                                width: 'min-content'
                            }
                        },
                        children: !!SelectedAppComponent && /*#__PURE__*/ jsx(SelectedAppComponent, {
                            onLinkClick: onLinkClick
                        })
                    }),
                    !isXL && /*#__PURE__*/ jsx(Stack.Item, {
                        grow: 1,
                        basis: 0,
                        shrink: 0,
                        styles: {
                            root: {
                                width: 'min-content'
                            }
                        },
                        children: ' '
                    })
                ]
            })
        ]
    });
};

export { IndustriesMenu as default };
